import i18n from '../../../i18n';

const getDefaultState = () => ({
  items: [
    {
      subheading: i18n.t('navigationSubheadings.general'),
      pages: [
        {
          title: i18n.t('pages.dashboard'),
          to: { name: 'Dashboard' },
          icon: 'ballot',
        },
        {
          title: i18n.t('pages.twenty'),
          href: process.env.TWENTY_FRONT_PAGE,
          icon: 'launch',
        },
      ],
    },
    {
      subheading: i18n.t('navigationSubheadings.webContent'),
      pages: [
        {
          title: i18n.t('pages.filters'),
          to: { name: 'FilterWrapper' },
          icon: 'filter_list',
        },
        {
          title: 'Review',
          to: { name: 'ReviewWrapper' },
          icon: 'ballot',
        },
        {
          title: i18n.t('pages.reviewSettings'),
          to: { name: 'ReviewSettingsWrapper' },
          icon: 'settings',
        },
        {
          title: i18n.t('pages.giftVoucherTemplates'),
          to: { name: 'GiftVoucherTemplates' },
          icon: 'mail',
        },
      ],
    },
  ],
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/nav/defaultState.js